import { AxiosResponse } from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ISharedAudio } from "../../../../../../../common/types/game/sharedAudio";
import { get, post } from "../../../../../../actions/general";
import { Title } from "../../../../../Form";
import Modal from "../../../../../Modal";
import { IProps } from "./interfaces";
import { Item, ItemTitle } from "./styles";

const AudioLinkerModal = ({ close, handleLinkAudio }: IProps) => {
    const dispatch = useDispatch();
    const [sharedAudios, setSharedAudios] = useState<ISharedAudio[]>([]);
    const getSharedAudios = () => {
        dispatch(get("game/shared-audio", (res: AxiosResponse<ISharedAudio[]>) => {
            setSharedAudios(res.data);
        }));
    }
    useEffect(() => {
        getSharedAudios();
    }, []);
    const handleDeleteAudio = (sharedAudio: ISharedAudio) => {
        dispatch(post(`game/shared-audio/${sharedAudio._id}/delete`, {}, () => {
            setSharedAudios(list => list.filter(item => item._id !== sharedAudio._id));
        }));
    }
    return (
        <Modal close={close}>
            <Title>Link audio</Title>
            {sharedAudios.map(sharedAudio => (
                <Item key={sharedAudio._id}>
                    <ItemTitle>{sharedAudio.title} ({sharedAudio.useage})</ItemTitle>
                    {sharedAudio.useage === 0 && (
                        <button className="button button--light button--with-margin-right" onClick={() => handleDeleteAudio(sharedAudio)}>
                            Delete
                        </button>
                    )}
                    <button className="button" onClick={() => handleLinkAudio(sharedAudio)}>
                        Select
                    </button>
                </Item>
            ))}
        </Modal>
    );
};

export default AudioLinkerModal;
